import { useLingui } from '@lingui/react'
import { type ReactElement } from 'react'

import Flag from 'views/components/atoms/Flag'
import IconCircleInfoOutline from 'views/components/atoms/Icon/IconCircleInfoOutline'

import './NowLabelWithZipInteraction.scss'

interface INowLabelWithZipInteraction {
  nowEligible: boolean
  displayNowWidget: boolean
}

const NowLabelWithZipInteraction: (
  props: INowLabelWithZipInteraction
) => ReactElement = ({ nowEligible, displayNowWidget }) => {
  const { i18n } = useLingui()
  return nowEligible || displayNowWidget ? (
    <Flag
      label={i18n._('product.label.nowProductGroup')}
      nowLabelGray={!nowEligible}
      nowWidget={nowEligible}
    >
      <div className="u-padding-x-small--left l-flex m-NowWidget__icon-wrapper">
        <IconCircleInfoOutline size="x-small" />
      </div>
    </Flag>
  ) : (
    <div />
  )
}

export default NowLabelWithZipInteraction
